/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CoursePriceWithRefundData } from './CoursePriceWithRefundData';
import { TenantAccessPlanWithRefundData } from './TenantAccessPlanWithRefundData';
const PaymentOptionsParser = /* #__PURE__ */ parsers.object([
    [
        'coursePurchase',
        /* #__PURE__ */ parsers.maybeNull(CoursePriceWithRefundData),
        'course_purchase',
    ],
    [
        'accessPlans',
        /* #__PURE__ */ codecArray(TenantAccessPlanWithRefundData),
        'access_plans',
    ],
]);
export class PaymentOptions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PaymentOptionsParser.decode(input).map(res => new PaymentOptions(res));
    }
    static unsafeDecode(input) {
        return PaymentOptions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PaymentOptionsParser.encode(data);
    }
    static schema() {
        return PaymentOptionsParser.schema();
    }
}
